import React from 'react'
import PropTypes from 'prop-types'

import Box from '../../Box'
import Button from '../../Button'

const DashboardControls = (props) => {
  const { callbacks: { showAddDashboardModuleModal, toggleEditDashboard } } = props

  return (
    <Box
      backgroundColor="white"
      border="1px solid"
      borderColor="lineColor"
      borderRadius="5px"
      justifyContent={['center', 'flex-end']}
      marginTop="large"
      padding="large"
      width="100%"
    >
      <Button
        buttonStyle="secondaryEdit"
        onClick={showAddDashboardModuleModal}
        size="medium"
        style={{ width: 'auto' }}
      >
        Add Module
      </Button>

      <Button
        buttonStyle="secondaryCreate"
        onClick={toggleEditDashboard}
        size="medium"
        style={{ marginLeft: 8, width: 'auto' }}
      >
        Save Dashboard
      </Button>
    </Box>
  )
}

DashboardControls.propTypes = {
  callbacks: PropTypes.shape({
    showAddDashboardModuleModal: PropTypes.func.isRequired,
    toggleEditDashboard: PropTypes.func.isRequired,
  }).isRequired,
}

export default DashboardControls

